module.exports = __webpack_public_path__ + "static/media/HiringHQ_Dark .b480c6cd.png";